// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getCategoriasRuta as listCategoriasRutaAPI,
    getCategoriaRuta as getCategoriaRutaAPI,
    addCategoriaRuta as addCategoriaRutaAPI,
    updateCategoriaRuta as updateCategoriaRutaAPI,
    deleteCategoriaRuta as deleteCategoriaRutaAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { categoriasRutaApiResponseError, categoriasRutaApiResponseSuccess } from './actions';
import { CategoriasRutaActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getCategoriaRuta({ payload: { id } }) {
    try {
        const response = yield call(getCategoriaRutaAPI, id );
        const categoriaItem = response.data.data;
        yield put(categoriasRutaApiResponseSuccess(CategoriasRutaActionTypes.GET_CATEGORIA_RUTA, categoriaItem));
    } catch (error) {
        yield put(categoriasRutaApiResponseError(CategoriasRutaActionTypes.GET_CATEGORIA_RUTA, error));
    }
}

function* addCategoriaRuta({payload:categoria}){
    try{
        const response = yield call(addCategoriaRutaAPI,{...categoria})
        const categoriaItem = response.data
        yield put(categoriasRutaApiResponseSuccess(CategoriasRutaActionTypes.ADD_CATEGORIA_RUTA,categoriaItem))
    } catch(error){
        yield put(categoriasRutaApiResponseError(CategoriasRutaActionTypes.ADD_CATEGORIA_RUTA,error))
    }
}

function* updateCategoriaRuta({payload:categoria}){
    try{
        const response = yield call(updateCategoriaRutaAPI,{...categoria})
        const categoriaItem = response.data.data
        yield put(categoriasRutaApiResponseSuccess(CategoriasRutaActionTypes.UPDATE_CATEGORIA_RUTA,categoriaItem))
    }catch(error){
        yield put(categoriasRutaApiResponseError(CategoriasRutaActionTypes.UPDATE_CATEGORIA_RUTA,error))
    }
}
function* deleteCategoriaRuta({payload:{id}}){
    try{
        const response = yield call(deleteCategoriaRutaAPI,id)
        const categoriaItem = response.data.id
        yield put(categoriasRutaApiResponseSuccess(CategoriasRutaActionTypes.DELETE_CATEGORIA_RUTA,categoriaItem))
    }catch(error){
        yield put(categoriasRutaApiResponseError(CategoriasRutaActionTypes.DELETE_CATEGORIA_RUTA,error))
    }
}

/**
 * List contactos
 */
function* listCategoriasRuta({payload:params}) {
    try {
        const response = yield call(listCategoriasRutaAPI, { ...params });
        const listaCategorias = response.data.data;
        yield put(categoriasRutaApiResponseSuccess(CategoriasRutaActionTypes.LIST_CATEGORIAS_RUTA, listaCategorias));
    } catch (error) {
        yield put(categoriasRutaApiResponseError(CategoriasRutaActionTypes.LIST_CATEGORIAS_RUTA, error));
    }
}


export function* watchGetCategoriaRuta(): any {
    yield takeEvery(CategoriasRutaActionTypes.GET_CATEGORIA_RUTA, getCategoriaRuta);
}

export function* watchListCategoriasRuta(): any {
    yield takeEvery(CategoriasRutaActionTypes.LIST_CATEGORIAS_RUTA, listCategoriasRuta);
}

export function* watchAddCategoriaRuta():any{
    yield takeEvery(CategoriasRutaActionTypes.ADD_CATEGORIA_RUTA,addCategoriaRuta)
}
export function* watchUpdateCategoriaRuta():any{
    yield takeEvery(CategoriasRutaActionTypes.UPDATE_CATEGORIA_RUTA,updateCategoriaRuta)
}
export function* watchDeleteCategoriaRuta():any{
    yield takeEvery(CategoriasRutaActionTypes.DELETE_CATEGORIA_RUTA,deleteCategoriaRuta)
}


function* categoriasRutaSaga(): any {
    yield all([
        fork(watchGetCategoriaRuta),
        fork(watchListCategoriasRuta),
        fork(watchAddCategoriaRuta),
        fork(watchUpdateCategoriaRuta),
        fork(watchDeleteCategoriaRuta),
    ]);
}

export default categoriasRutaSaga;
